import { render, staticRenderFns } from "./AttachmentSection.vue?vue&type=template&id=644f9007&"
import script from "./AttachmentSection.vue?vue&type=script&lang=js&"
export * from "./AttachmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports